export var AnomaliesSubjects;
(function (AnomaliesSubjects) {
    AnomaliesSubjects["SetupAnomalyButton"] = "setup-anomaly-button";
    AnomaliesSubjects["SetupAnomalyModal"] = "setup-anomaly-modal";
})(AnomaliesSubjects || (AnomaliesSubjects = {}));
//# sourceMappingURL=anomalies.enums.js.map